import React from "react";
import TreeView from 'devextreme-react/tree-view';
import Radiobox from '../Radiobox';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
export default class ProducerSelector extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			productorSelected: 0,
			checkedItems: [],
		};
		this.currentIndex = null;
		this.productoresData = [];
		this.productoresChildsSelected = [];
	}

	processItem = item => {
		let itemIndex = -1;
		const checkedItems = this.state.checkedItems;

		checkedItems.forEach((currentItem, index) => {
			if (currentItem.id === item.id) {
				itemIndex = index;
				return false;
			}
		});

		if (item.selected) {
			checkedItems.push(item);
		} else if (!item.selected) {
			checkedItems.splice(itemIndex, 1);
		}

		return checkedItems;
	};

	resetSelection = () => {
		this.setState({
			productorSelected: 0,
			checkedItems: []
		}, () => {
			Array.from(document.getElementsByClassName('chkProductor')).forEach(f => { f.disabled = true; f.checked = false; });
			this.productoresData.forEach(item => {
				item.items.forEach(internal => {
					internal.selected = false;
					internal.items.forEach(internal2 => {
						internal2.selected = false;
					});
				});
			});
			this.currentIndex = null;
		});
	};

	setProductorDefault = code => {
		let index = null;
		this.productoresData.forEach((item, i) => {
			if (item.id === code) {
				index = (i + 1);
				return false;
			}
		});

		if (index !== null) {
			let checkbox = document.getElementsByClassName(`chkProductorCode_${code}`)[0];
			Array.from(document.getElementsByClassName('chkProductor')).forEach(f => { f.disabled = true; f.checked = false; });
			checkbox.disabled = false;
			checkbox.click();

			if (this.currentIndex !== index) {
				this.productoresData.forEach(item => {
					item.items.forEach(internal => {
						internal.selected = (internal.id === `${code}X`);
						internal.items.forEach(internal2 => {
							internal2.selected = false;
						});
					});
				});
				this.currentIndex = index;
			}

			this.setProductorSelected(index);
			this.setState({ productorSelected: index }, () => {
				this.props.onCheckedItemsChanged(this.state.checkedItems, true);
			});
		}
	}

	setProductorSelected = index => {
		let root = [];
		let items = this.productoresData[index - 1].items.length ? this.productoresData[index - 1].items.filter(f => f.selected) : [];

		items.forEach(f => {
			root.push({
				category: "",
				id: f.id,
				itemData: {},
				selected: true,
				text: f.text,
				core: f.core
			});
		});

		this.setState({ productorSelected: index, checkedItems: root }, () => {
			this.props.onCheckedItemsChanged(this.state.checkedItems);
			this.props.onProducerIdChanged(index);
		});
	}

	onProducersChange = (newProducers) => {
		this.productoresData = newProducers;
		this.resetSelection();
	};

	setProductoresSelectedAll = e => {
		let checkAll = e.value;
		if (checkAll !== undefined) {
			e.component.getNodes().forEach((node) => this.setProductoresSelected({ node }));
		}
	}

	setProductoresSelected = e => {
		const nodeItem = e.node;
		let checkedItemsNew = [];

		if (nodeItem.items.length) {
			nodeItem.items.forEach(item => {
				checkedItemsNew = this.processItem({
					id: item.key,
					text: item.text,
					core: item.itemData.core,
					itemData: item.itemData,
					selected: item.selected,
					category: item.parent ? item.parent.text : ""
				});
			});
		}

		checkedItemsNew = checkedItemsNew.concat(this.processItem({
			id: nodeItem.key,
			text: nodeItem.text,
			core: nodeItem.itemData.core,
			itemData: nodeItem.itemData,
			selected: nodeItem.selected,
			category: nodeItem.parent ? nodeItem.parent.text : ""
		}));

		checkedItemsNew = checkedItemsNew.filter((v, i, a) => a.findIndex(t => (t.id === v.id && t.name === v.name)) === i);
		this.setState({ checkedItems: checkedItemsNew }, () => {
			this.props.onCheckedItemsChanged(this.state.checkedItems);
		});
	};

	enabledCheckbox = (e, index) => {
		let checkbox = e.target.closest('.row.productores-selector').querySelector('.chkProductor');

		if (e.target.control && e.target.control.type === "radio" && checkbox.checked === false) {
			Array.from(document.getElementsByClassName('chkProductor')).forEach(f => { f.disabled = true; f.checked = false; });
			document.getElementById(index).disabled = false;
			checkbox.click();

			if (this.currentIndex !== index) {
				this.productoresData.forEach(item => {
					item.items.forEach(internal => {
						internal.selected = false;
						internal.items.forEach(internal2 => {
							internal2.selected = false;
						});
					});
				});
				this.currentIndex = index;
			}

			this.setProductorSelected(index);
			this.setState({ productorSelected: index }, () => {
				this.props.onCheckedItemsChanged(this.state.checkedItems);
			});

			e.preventDefault();
			e.stopPropagation();
		}
	};

	renderTreeViewItem = value => (
		<div title={`${value.text.trim()} - CORE: ${value.core}`}>{value.text}</div>
	);

	getProductorFromText(text) {
		return text.substring(text.indexOf(")") + 1).trim();
	}

	getDivisionFromCore(core) {
		if (core === "VT") return "VIDA Y GENERALES";
		if (core === "RVT") return "RETIRO";
		return core;
	}

	render() {
		this.productoresData = this.props.producers.filter(x => x.core !== 'EOS');
		return (
			<>
				<div className="row">
					<div className="col-6 pt-3"><span>División</span></div>
					<div className="col-6 pt-3">
						{this.state.productorSelected > 0 &&
							this.productoresData.some((menu, index) =>
								menu.items?.length > 0 && index + 1 === this.state.productorSelected
							) && <span>Productor</span>}
					</div>
				</div>
				<div className="row">
					<div className="col-6 pt-2">
						<ul className="list-group">
							{this.productoresData.map((menu, index) => (
								<li key={index} className="list-group-item p-2 row productores-selector">
									<div
										className="d-flex align-items-center"
										onClick={(e) => this.enabledCheckbox(e, index + 1)}
										style={{ cursor: 'pointer' }}
									>
										<div className="customquares me-2">
											<Radiobox
												id={index + 1}
												value={index + 1}
												groupName="DivisionSelection"
												className={`chkProductor chkProductorCode_${menu.id}`}
												disabled={true}
												onChange={(e) => this.setProductorSelected(index + 1)}
											/>
										</div>
										<i className="bi bi-person me-2"></i>
										<strong title={`${menu.text} - CORE: ${menu.core}`}>
											{this.getProductorFromText(menu.text)} - {this.getDivisionFromCore(menu.core)}
										</strong>
									</div>
									<hr className="mt-2 mb-2" />
								</li>
							))}
						</ul>
					</div>
					{!this.props.hideChilds && (
						<div className="col-6 pt-2 mt-2">
							{this.state.productorSelected > 0 &&
								this.productoresData.map((menu, index) => (
									menu.items?.length > 0 && index + 1 === this.state.productorSelected && (
										<div key={index} className="row productores-tree">
											<TreeView
												id={`selection-treeview_${index}`}
												items={menu.items}
												width="100%"
												selectNodesRecursive={true}
												showCheckBoxesMode={menu.items.length > 1 ? "selectAll" : "normal"}
												selectAllText="Todos"
												selectionMode={this.props.selectionMultiple ? "multiple" : "single"}
												onItemSelectionChanged={this.setProductoresSelected}
												onSelectAllValueChanged={this.setProductoresSelectedAll}
												itemRender={this.renderTreeViewItem}
											/>
										</div>
									)
								))}
						</div>
					)}
				</div>
			</>
		);
	}
}

ProducerSelector.defaultProps = {
	producers: [],
	hideChilds: false,
	selectionMultiple: true
};
